<template>
  <div>
    <v-container fluid>

      <div class="main">

        <div class="text-end my-3">
          <v-btn class="rounded-lg"
                 color="gifty"
                 dark
                 depressed
                 @click="$refs.createDialog.open()"
          >
            <v-icon left>mdi-plus</v-icon>
            Ajouter un POS
          </v-btn>
        </div>

        <v-card class="rounded-lg shadow">

          <v-overlay :value="overlay"
                     absolute
                     color="white"
                     opacity="0.5">
            <v-progress-circular
                color="primary"
                indeterminate
                size="50"
            ></v-progress-circular>
          </v-overlay>

          <v-card-title>
            <div>
              <v-text-field
                  v-model="keyword"
                  append-icon="mdi-magnify"
                  @keydown.enter="getSalepoints"
                  hint="Appuyez sur ↵ Entrée pour rechercher"
                  clearable
                  @click:clear="[keyword=null,getSalepoints()]"
                  dense
                  filled
                  persistent-hint
                  placeholder="Recherche..."
                  rounded
              ></v-text-field>
            </div>

            <v-spacer/>

            <v-btn color="grey"
                   text
                   @click="getSalepoints">
              <v-icon left>mdi-refresh</v-icon>
              Mettre à jour
            </v-btn>

            <v-btn color="grey"
                   @click="exportData"
                   text
                   :loading="exportLoading"
            >
              <v-icon left>mdi-filter-outline</v-icon>
              Exporter
            </v-btn>

            <v-btn color="grey"
                   text
            >
              <v-icon left>mdi-filter-outline</v-icon>
              Filtrer
            </v-btn>

          </v-card-title>

          <v-divider/>

          <v-card-text v-if="isLoading" class="pa-0">
            <v-skeleton-loader type="table"/>
          </v-card-text>

          <div v-else>

            <v-card-text>

              <v-simple-table v-if="salepoints.length" class="table-border rounded-lg">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>Statut</th>
                    <th>Nom complet</th>
                    <th>Téléphone</th>
                    <th>Type</th>
                    <th>Wilaya</th>
                    <th>Commune</th>
                    <th>Adresse</th>
                    <th>Map</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item ,index) in salepoints" :key="index">

                    <td>
                      <v-switch color="success"
                                @click="changeStatus(item.id)"
                                class="pa-0 ma-0"
                                readonly
                                hide-details
                                v-model="item.is_active"></v-switch>

                    </td>

                    <td>
                      {{ item.salepoint?.pos_name }}
                    </td>

                    <td>
                      <span class="font-weight-medium">
                     {{ item.salepoint?.owner_phone }}
                     </span>
                    </td>

                    <td>
                      <v-chip color="white" text-color="gifty">
                        <v-icon left small>mdi-tag</v-icon>
                        {{ item.salepoint?.salepoint_type?.name }}
                      </v-chip>
                    </td>

                    <td>
                      {{ item.salepoint?.wilaya?.name }}
                    </td>

                    <td>
                      {{ item.salepoint?.commune?.name }}
                    </td>

                    <td>
                      {{ item.salepoint?.adress }}
                    </td>

                    <td>
                      <v-btn color="info"
                             icon
                             class="v-btn--active"
                             @click="openGoogleMaps(item.salepoint.latitude, item.salepoint.longitude)">
                        <v-icon>
                          mdi-map-marker
                        </v-icon>
                      </v-btn>
                    </td>

                    <td>
                      <div class="d-flex align-center">
                        <v-btn color="gifty" icon @click="$refs.detailsDialog.open(item)">
                          <v-icon>mdi-eye-plus-outline</v-icon>
                        </v-btn>
                        <v-btn color="gifty" icon>
                          <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <v-btn color="gifty" icon @click="remove(item.id)">
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </div>
                    </td>

                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <div v-else>
                <NoResults @reload="getSalepoints"/>
              </div>


            </v-card-text>


            <v-divider v-if="total > 1"/>

            <v-card-actions v-if="total > 1">

              <div :style="{width : '120px'}">
                <v-select v-model="perPage"
                          :items="[10,20,30,50,100]"
                          dense
                          hide-details
                          label="Ligne par page"
                          outlined
                ></v-select>
              </div>

              <v-spacer/>


              <v-pagination v-if="total > 1"
                            v-model="pagination.current"
                            :length="pagination.total"
                            circle
                            total-visible="7"
                            @input="getSalepoints"></v-pagination>

            </v-card-actions>

          </div>
        </v-card>

      </div>

    </v-container>

    <CreateDialog ref="createDialog" @refresh="getSalepoints"/>
    <DetailsDialog ref="detailsDialog"/>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults";
import CreateDialog from "@/views/payment_salepoints/components/CreateDialog.vue";
import DetailsDialog from "@/views/payment_salepoints/components/DetailsDialog.vue";

export default {
  components: {
    CreateDialog,
    DetailsDialog,
    NoResults,
  },
  data() {
    return {
      id: '',
      keyword: '',
      exportLoading: false,
      overlay: false,
      isLoading: false,
      salepoints: [],
      perPage: 10,
      total: 0,
      pagination: {
        current: 1,
        total: 0
      },
    };
  },
  methods: {
    getSalepoints() {
      this.isLoading = true
      HTTP.get('/v1/payment-salepoints?page=' + this.pagination.current, {
        params: {
          keyword: this.keyword,
          limit: this.limit,
          database_ids: this.database_ids,
        }
      }).then(res => {
        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;
        this.salepoints = res.data.data.data
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    openGoogleMaps(lat, lng) {
      const url = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(url, "_blank");
    },
    remove(id) {
      this.id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.overlay = true;
      HTTP.delete("/v1/payment-salepoints/" + this.id + "/delete").then(() => {
        this.overlay = false;
        let i = this.salepoints.findIndex((el) => el.id === this.id);
        this.$delete(this.salepoints, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    changeStatus(id) {
      this.overlay = true;
      HTTP.post("/v1/payment-salepoints/" + id + "/change-status").then(() => {
        this.overlay = false;
        let index = this.salepoints.findIndex((el) => el.id === id);
        this.salepoints[index].is_active = !this.salepoints[index].is_active
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    exportData() {
      this.exportLoading = true
      HTTP.post('/v1/payment-salepoints/export', {}, { responseType: 'blob' })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const a = document.createElement('a')
            a.href = url
            a.download = 'payment_salepoints.xlsx'
            document.body.appendChild(a)
            a.click()
            a.remove()
            window.URL.revokeObjectURL(url)
            this.exportLoading = false
          })
          .catch((err) => {
            console.error('Erreur export:', err)
            this.exportLoading = false
          })
    }
  },
  created() {
    this.getSalepoints()
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem()
        this.$is_confirm = false
      }
    }
  }
};
</script>

<style scoped>
</style>
